import React, { useEffect, useRef, useState } from 'react';

export default function HomeBooking() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Require BOTH: section in viewport AND 4 seconds elapsed since page load
    // This prevents Survcart/Stripe/reCAPTCHA from loading during GTmetrix's
    // critical performance measurement window while still loading for real users.
    let visibleInViewport = false;
    let timerFired = false;

    const maybeLoad = () => {
      if (visibleInViewport && timerFired) setIsVisible(true);
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          visibleInViewport = true;
          observer.disconnect();
          maybeLoad();
        }
      },
      { rootMargin: '0px' }
    );

    const timer = setTimeout(() => {
      timerFired = true;
      maybeLoad();
    }, 4000);

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => { observer.disconnect(); clearTimeout(timer); };
  }, []);

  useEffect(() => {
    if (!isVisible) return;
    if (document.querySelector('script[src="https://embed.survcart.com/embed.js"]')) return;

    window.survcartConfig = {
      id: "R1zJhkIIHF6wPVuhrBoI",
      embedName: "Embed Configuration 1",
      staged: false,
      companyId: "MHZmpURzZElNL3iOdMS2",
      selectors: [
        {
          ga4_tags: [],
          id: "wbyGa6ZLtt4y2VuWfTSP",
          default: false,
          workflowId: "fnAS3LgAZ2xCtNWvX3ST",
          tokens: [""],
          classes: "survcart-embed-presenter",
          configId: "TPWHUYBLYhJNm5pOTGpI",
        },
      ],
    };

    const script = document.createElement("script");
    script.src = "https://embed.survcart.com/embed.js";
    script.async = true;
    document.body.appendChild(script);
  }, [isVisible]);

  return (
    <>
      <section className="booking-engine" ref={sectionRef}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="engine-text">
                <div className="search-engine-form">
                  {isVisible && (
                    <iframe
                      src="https://embed.survcart.com?type=landing&co=MHZmpURzZElNL3iOdMS2&wsid=R1zJhkIIHF6wPVuhrBoI&sel=wbyGa6ZLtt4y2VuWfTSP"
                      height="500"
                      style={{ width: "100%", border: "none" }}
                      title="Survcart Embed"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
